import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";

function FormSelectProductType({
	inputValue,
	inputOnChange,
	inputLabelName,
}: {
	inputValue: number;
	inputLabelName: string;
	inputOnChange: (newValue: number) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const PRODUCT_TYPES = [
		{ name: "M2000", id: 0 },
		{ name: "M3000", id: 1 },
		{ name: "M4000", id: 2 },
		{ name: "ICue", id: 3 },
		{ name: "ICueImp", id: 4 },
		{ name: "Dispatcher", id: 5 },
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{inputLabelName}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e);
						}}
						value={inputValue}
					>
						{PRODUCT_TYPES.map((item: { name: string; id: number }) => (
							<Option key={item.id} value={item.id}>
								{item.name}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}

export default FormSelectProductType;
